import FetchGetDataWithAuthNEW from "../services/FetchGetDataWithAuthNEW";

export default function FechGetOneTicket(club, id) {

  var url = "/reservation/get_ticket_by_id/" + club + "/" + id;

  return FetchGetDataWithAuthNEW(url);
}

